export default "__VITE_ASSET__8f91610e__"